var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSleepActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.18 18.489a6.453 6.453 0 01-2.604-.53 6.8 6.8 0 01-2.116-1.43 6.8 6.8 0 01-1.43-2.117 6.453 6.453 0 01-.53-2.604c0-1.411.397-2.69 1.19-3.837a6.292 6.292 0 013.192-2.414.697.697 0 01.678.091c.21.149.309.35.298.604-.033.937.116 1.83.446 2.679.331.848.827 1.604 1.489 2.265a6.526 6.526 0 002.265 1.488c.85.331 1.742.48 2.68.447.286-.011.498.085.636.29.138.203.163.432.074.686a6.546 6.546 0 01-2.439 3.183 6.519 6.519 0 01-3.828 1.199zm0-1.323c.971 0 1.87-.243 2.696-.728a5.235 5.235 0 001.952-2 8.204 8.204 0 01-2.696-.72 7.861 7.861 0 01-2.282-1.596 7.995 7.995 0 01-1.604-2.282 7.808 7.808 0 01-.711-2.695 5.158 5.158 0 00-1.993 1.96 5.324 5.324 0 00-.72 2.703c0 1.488.522 2.753 1.564 3.795 1.042 1.042 2.307 1.563 3.795 1.563z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 8,
    r: 2,
    fill: "#17BED0"
  })));
}
export default SvgSleepActive;